import { render, staticRenderFns } from "./sceRadioButton.vue?vue&type=template&id=1271c6ed"
import script from "./sceRadioButton.vue?vue&type=script&lang=js"
export * from "./sceRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports